import React, { useEffect, useState } from "react";
import AdminLayout from "../../layout/AdminLayout";
import { Pagination } from "react-bootstrap";
import { commonData } from "../../data/CommonData";
import Classes from "../../asset/styles/AdminCMSSettings.module.css";
import AdminEditCMSModal from "../../Modals/AdminEditCMSModal";
import { getAllCMSList } from "../../actions/adminAction";
import { Modal } from "react-bootstrap";
import { IoMdClose } from "react-icons/io";
import { isEmpty } from "../../lib/isEmpty";
import { createLandingHeaderContent, getAllLandingHeaderContent } from "../../actions/cmsActions";

const AdminCMSSettings = () => {
  const [editCMS, setEditCMS] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);

  const handleShowEditCMS = (item) => {
    setEditCMS(true);
    seteditRecord(item);
  };
  const handleCloseEditCMS = () => {
    seteditRecord({});
    setEditCMS(false);
  };
  const [cmsData, setCMSData] = useState();
  const [editRecord, seteditRecord] = useState();


  // --------------OLD-------CODE-----------//

  // const getCMS = async (e) => {
  //   try {
  //     const { status, loading, message, result } = await getAllCMSList();
  //     // if (status == true) {
  //     //   setCMSData(result);
  //     // }
  //   } catch (err) {
  //     console.log("🚀 ~ getCMS ~ err:", err);
  //   }
  // };

  // --------------OLD--CODE----------------//


  const [showModal, setShowModal] = useState(false);
  const [formvalue, setFormValue] = useState({
    identifier: '',
    title: '',
    content: ''
  });

  const handleShowAddCMS = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const handleSave = async () => {
    console.log(formvalue);
    let payload = { data: formvalue };
    const result = await createLandingHeaderContent(payload);
    if (result.statusCode == 200 && result.status == true) {
      listOfCms()
    }

    setShowModal(false);
  };

  const pageLimit = 5;
  const payload = {
    page: currentPage, limit: pageLimit
  }

  const listOfCms = async () => {
    try {
      setLoading(true);
      const result = await getAllLandingHeaderContent(payload);
      if (result.statusCode == 200 && result.status == true) {
        const dataResult = result.data.content;
        setCMSData(dataResult);
        setTotalPages(result.data.pagination.totalPages);
      } else {
        setCMSData([]);
      }
      setLoading(false);
    } catch (error) {

    }
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  useEffect(() => {
    // getCMS();
    listOfCms()
  }, [currentPage]);

  return (
    <>
      <AdminLayout>
        <div className={`${Classes.adminChangeCont} p-2 p-sm-3 p-md-4 p-lg-5`}>
          <h2
            className={`${Classes.launchpad__title} text-uppercase aboro_font`}>
            CMS Settings
          </h2>
          {/* ----------------------- */}

          {/* <button
            className={`${Classes.kycViewButton} border-0 outline-0 p-3 pointer position-relative`}
            onClick={handleShowAddCMS}
          >
            Add
          </button> */}

          <Modal
            size="md"
            centered
            backdrop="static"
            keyboard={false}
            className={`cmnModal`}
            show={showModal}
            onHide={handleCloseModal}
          >
            <Modal.Body>
              <div className={`${Classes.modalHeader} text-end`}>
                <button
                  className={`${Classes.modalCloser}`}
                  onClick={handleCloseModal}
                >
                  <IoMdClose />
                </button>
              </div>
              <h5 className={`${Classes.modalTitle} m-0 text-center roboto mt-3 text-uppercase`}>
                Add CMS Settings
              </h5>

              <div className={`${Classes.singleInpHolder} mt-3`}>
                <label for="identifier" className={`${Classes.inputLabel} orbitron`}>
                  Identifier
                </label>
                <br />
                <input
                  type="text"
                  id="identifier"
                  name="identifier"
                  value={formvalue?.identifier}
                  className={`${Classes.inputBox} inter_font mt-3 w-100 p-2`}
                  placeholder=""
                  autoComplete="off"
                  onChange={(e) => setFormValue({ ...formvalue, identifier: e.target.value })}
                />
              </div>

              <div className={`${Classes.singleInpHolder} mt-3`}>
                <label for="title" className={`${Classes.inputLabel} orbitron`}>
                  Title
                </label>
                <br />
                <input
                  type="text"
                  id="title"
                  name="title"
                  value={formvalue?.title}
                  onChange={(e) => setFormValue({ ...formvalue, title: e.target.value })}
                  className={`${Classes.inputBox} inter_font mt-3 w-100 p-2`}
                />
              </div>

              <div className={`${Classes.singleInpHolder} mt-3`}>
                <label for="content" className={`${Classes.inputLabel} orbitron`}>
                  Content
                </label>
                <br />
                <textarea
                  className={`${Classes.textArea} w-100 mt-2 p-2 inter_font`}
                  id="content"
                  name="content"
                  value={formvalue?.content}
                  onChange={(e) => setFormValue({ ...formvalue, content: e.target.value })}
                  rows={3}
                  cols={50}
                />
              </div>

              <div className={`text-center w-100 mt-4`}>
                <button
                  className={`${Classes.whiteBtn} poppins`}
                  onClick={handleSave}
                >
                  Save
                </button>
              </div>
            </Modal.Body>
          </Modal>


          {/* ----------------------- */}
          <div className={`${Classes.cmnTableHolder}`}>
            <table className={`${Classes.tokenCmnTable} mt-5`}>
              <thead>
                <tr>
                  <th className="px-3 py-2">Identifier</th>
                  <th className="px-3 py-2">Content</th>
                  <th className="px-3 py-2">Action</th>
                </tr>
              </thead>
              <tbody>
                {cmsData && cmsData.length > 0
                  ?
                  cmsData.map((item) => (
                    <tr className={`${Classes.gradientBorder}`} key={item._id}>
                      <td className="px-3 py-1">
                        <p className={`${Classes.tableTokenName} poppins m-0 position-relative py-3`}>
                          {item?.identifier}
                        </p>
                      </td>

                      <td className="px-3 py-1">
                        <p className={`${Classes.tableTokenName} poppins m-0 position-relative py-3`}>
                          {item?.content}
                        </p>
                      </td>

                      <td className={`px-0 py-1 text-center`}>
                        <button
                          className={`${Classes.kycViewButton} border-0 outline-0 p-3 pointer position-relative`}
                          onClick={() => {
                            handleShowEditCMS(item);
                          }}
                        >
                          Edit
                        </button>
                      </td>
                    </tr>
                  ))
                  :
                  <tr>
                    <td colSpan={4} className="text-center b_wdth poppins pt-5">No Data Found</td>
                  </tr>
                }
              </tbody>
            </table>

            {/* Pagination Controls */}
            {/* <div className={`${Classes.paginationContainer}`}>
              <button
                className={`${Classes.pageButton}`}
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                Previous
              </button>

              {[...Array(totalPages)].map((_, index) => (
                <button
                  key={index}
                  className={`${Classes.pageButton} ${currentPage === index + 1 ? Classes.activePage : ''}`}
                  onClick={() => handlePageChange(index + 1)}
                >
                  {index + 1}
                </button>
              ))}

              <button
                className={`${Classes.pageButton}`}
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div> */}
          </div>
          {/* <Pagination>
            <Pagination.Prev />
            <Pagination.Item active>{1}</Pagination.Item>
            <Pagination.Item>{2}</Pagination.Item>
            <Pagination.Item>{3}</Pagination.Item>
            <Pagination.Next />
          </Pagination> */}
        </div>
      </AdminLayout>

      {/* modal content */}
      <AdminEditCMSModal
        show={editCMS}
        record={editRecord}
        getcms={listOfCms}
        handleClose={handleCloseEditCMS}
      />
      {/* end of modal content */}
    </>
  );
};

export default AdminCMSSettings;
